<template>
  <v-list-item-content>
    <div class="d-flex align-center">
      <span>{{ item.displayName }}</span>
      <v-icon
        v-if="item.login"
        class="ml-2 grey--text"
        x-small
      >
        mdi-slash-forward
      </v-icon>
      <span
        v-if="item.login"
        class="grey--text"
      >
        {{ item.login }}
      </span>
    </div>
    <div class="text-caption grey--text user-details">
      <span
        v-if="item.isAttorney"
      >
        Attorney
      </span>
      <span>
        {{ item.userType }}
      </span>
      <span
        v-if="item.disabled"
        class="grey--text text--darken-2"
      >
        Inactive
      </span>
    </div>
  </v-list-item-content>
</template>

<script>
export default {
  name: 'UserSelectListItem',

  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  computed: {
    item () { return this.user || {} },
  },
}
</script>

<style scoped>
.user-details {
  *::after {
    content: "\2022";
    display: inline;
    margin-right: 4px !important;
    margin-left: 4px !important;
  }
  :last-child::after {
    display: none;
  }
}
</style>
